module.exports = __webpack_public_path__ + "static/media/info-information.4ce9bce4.png";